/**
 * Carrega o tema do user_settings assim que o usuário está autenticado.
 * Garante que o tema (incl. "sistema") seja aplicado na navegação, não só ao abrir Perfil.
 */

import { useEffect } from 'react'
import { useSessionStore } from '@/features/session/model/sessionStore'
import { useThemeStore } from '@/shared/lib/themeStore'

export const ThemeLoader = () => {
  const user = useSessionStore((s) => s.user)

  useEffect(() => {
    if (!user?.id) return
    void useThemeStore.getState().hydrateForUser(user.id)
  }, [user?.id])

  return null
}
